/**
 * Pick subscription templates from GET /price/subscription-templates (`store.stripe.subscriptionTemplates`).
 */

/** "Default set of prices for AppFolio customers" — template for AppFolio product type. */
export const SUBSCRIPTION_TEMPLATE_MATCH_APPFOLIO = {
  applicableCompanyProductType: 'LivableAppfolio'
};

/** "Default set of prices for regular customers" — template for Livable Pro product type. */
export const SUBSCRIPTION_TEMPLATE_MATCH_REGULAR = {
  applicableCompanyProductType: 'LivablePro'
};

/**
 * @param {Array<{ name?: string; applicableCompanyProductType?: string; products?: Array<{ defaultPriceId?: string | null }> }>} templates
 * @param {{ nameIncludes?: string; applicableCompanyProductType?: string }} match
 * @returns {string[]} Stripe price ids from `products[].defaultPriceId` (null/empty skipped).
 */
export function collectDefaultPriceIdsFromSubscriptionTemplates(templates, match) {
  var _template$products;
  const _ref = match || {},
    nameIncludes = _ref.nameIncludes,
    applicableCompanyProductType = _ref.applicableCompanyProductType;
  const hasType = applicableCompanyProductType != null && applicableCompanyProductType !== '';
  const hasName = Boolean(nameIncludes);
  if (!hasType && !hasName) return [];
  const rows = Array.isArray(templates) ? templates : [];
  const needle = hasName ? String(nameIncludes).toLowerCase() : '';
  const template = rows.find(t => {
    var _t$applicableCompanyP, _t$name;
    const type = (_t$applicableCompanyP = t === null || t === void 0 ? void 0 : t.applicableCompanyProductType) !== null && _t$applicableCompanyP !== void 0 ? _t$applicableCompanyP : '';
    const name = ((_t$name = t === null || t === void 0 ? void 0 : t.name) !== null && _t$name !== void 0 ? _t$name : '').toLowerCase();
    if (hasType && type !== applicableCompanyProductType) return false;
    if (hasName && !name.includes(needle)) return false;
    return true;
  });
  if (!(template !== null && template !== void 0 && (_template$products = template.products) !== null && _template$products !== void 0 && _template$products.length)) return [];
  return template.products.map(p => p === null || p === void 0 ? void 0 : p.defaultPriceId).filter(id => id != null && String(id).trim() !== '');
}